'use strict';

/* Controllers */
  // signin controller
app.controller('SigninFormController', ['$scope', '$http', '$state', '$stateParams', '$rootScope', function($scope, $http, $state, $stateParams, $rootScope) {
    //LogOut
    
    if( 'logout' === $stateParams.logOut ){
        $http({
            url: MyAjax.ajaxurl,
            method: "GET",
            params:{
                    action: 'log_out_user',
                },
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(function(response) {
                if(response.data.logout == "Logout Successful")
                   window.location.reload();       
        });
    }
    //LogIn
    $scope.user = {};
    var datax = {};
    $scope.authError = null;
    $scope.login = function() {
      $scope.authError = null;
      //Data
      //var ngdata = {email: $scope.user.email, password: $scope.user.password}
      // Try to login
            
      datax.email = ( typeof $scope.data.user !== "undefined" && $scope.data.user ) ? $scope.data.user : $scope.user.email;
      datax.password = $scope.user.password;
      datax.timeLock = ( $scope.lockType == 'timeLock' && typeof $scope.lockType !== "undefined" ) ? 'true' : 'false';
        
        $http({
          url: MyAjax.ajaxurl,
          method: "POST",
          params:{
                  action: 'get_log_in',
              },
          data: angular.toJson(datax), 
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function(response) {
            //console.log(response.data.user);

          if ( !response.data.user ) {
            $scope.authError = 'Wrong Credentials. Please try again.';
          }else{
            window.location.href = response.data.url;
          }
        }, function(x) {
          $scope.authError = 'Server Error';
        });
    };
  }]);
  
  /* Controllers */
  // signin controller
app.controller('InactiveFormController', ['$scope', '$http', '$state', '$stateParams', '$rootScope', function($scope, $http, $state, $stateParams, $rootScope) {
    $scope.user = {};
    var datau = {};
    $scope.authError = null;
    $scope.companyForm = function() {
      $scope.authError = null;
      //Data
      datau.desc = $scope.user.helpdes;
     
      $http({
        url: MyAjax.ajaxurl,
        ignoreLoadingBar: true,
        method: "POST",
        params:{
                action: 'post_activate_support',
            },
        data: angular.toJson(datau), 
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function(response) {
          //console.log(response.data.user);
          var msgbox = angular.element( document.querySelector( '#passmsg' ) );
          
        if ( response.data.thanks && !response.data.err) {
            msgbox.removeClass('alert-danger').addClass('alert-success');
            $scope.authError = response.data.thanks;
            
            var elemForm = document.getElementById("formbox");
            var elemInfo = document.getElementById("infobox");
            elemInfo.remove();
            elemForm.remove();
            
        }else{      
            msgbox.removeClass('alert-success').addClass('alert-danger');
            $scope.authError = response.data.err.replace(/\n\r?/g, '<br/>');
        }
      }, function(x) {
        $scope.authError = 'Server Error';
      });
    };
    
  }]);     
  

app.controller('ExpiredController', ['$scope', '$http', '$state', '$stateParams', '$rootScope', function($scope, $http, $state, $stateParams, $rootScope) {
    $http({
        url: MyAjax.ajaxurl,
        method: "GET",
        params: {
            action: 'get_data_expired',
        },
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(function (response) {
        if (response.data.expiry_list) {
            
           var renew_data = response.data.expiry_list;
           var packRenew = [];
           var count = 0;
           //$scope.packRew = [];
           
           if( typeof renew_data == 'undefined' || renew_data == false || renew_data == null )
               return;
           
           
           for (var key in renew_data ) {
                if (renew_data.hasOwnProperty(key)) {
                   for (var i = 0; i < renew_data[key].length; i++) {
                       packRenew[count] = renew_data[key][i]; 
                       //console.log(renew_data[key][i]);
                       count++;
                   } 
                }
              }
              
            $scope.packRew = packRenew;
              
            //console.log(packRenew);
            
            
        } else {
            //no data
            console.log('uji::Error no data!');
            //window.location.reload();
        }
    }, function (x) {
        $scope.authError = 'Server Error';
    });
    
    //Redirect Link    
    $scope.renewLink = function(url){
        if( typeof url !== 'undefined' || url != '' )
            window.open( url , '_blank');
    }
    
  }]); 